import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'callbackCalls',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Callback Calls',
  },
}

const keys = {
  statKey: 'callback_calls',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const callbackCalls = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { callbackCalls }
